export type APIFieldErrors = Record<string, string[] | string>

export interface APIError {
  statusCode?: number
  message: string
  data?: unknown
  errors: unknown
  raw: Error
}

export function isAPIFieldErrors(errors: unknown): errors is APIFieldErrors {
  if (!errors || Array.isArray(errors) || typeof errors !== 'object') {
    return false
  }

  const values = Object.values(errors as Record<string, unknown>)
  if (values.length === 0) {
    return false
  }

  return values.every((value) => {
    if (Array.isArray(value)) {
      return value.every((message) => typeof message === 'string')
    }
    return typeof value === 'string'
  })
}
